import { Button, VStack } from '@bonusly/design-system';

interface BizySidePanelSuggestedPromptsProps {
	prompts: string[];
	onSelectPrompt: (prompt: string) => void;
}

export function BizySidePanelSuggestedPrompts({ prompts, onSelectPrompt }: BizySidePanelSuggestedPromptsProps) {
	return (
		<VStack spacing="4px" align="flex-start" mb="8px">
			{prompts.map((prompt) => (
				<Button
					key={prompt}
					variant="outline"
					size="sm"
					borderRadius="12px"
					borderColor="border.default"
					color="text.softest"
					fontSize="sm"
					h="auto"
					py={1.5}
					px={3}
					whiteSpace="normal"
					textAlign="left"
					onClick={() => onSelectPrompt(prompt)}
					_hover={{ bg: 'secondary.bgAlpha', color: 'text.default' }}
				>
					{prompt}
				</Button>
			))}
		</VStack>
	);
}
